module.exports = __webpack_public_path__ + "static/img/erweima.b8ab128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/erweima.jpg
// module id = Xhen
// module chunks = 1